
import React, { useState } from 'react';
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import DisciplineRecords from 'pages/general/DisciplineRecords';
import RecordsTable from 'pages/general/RecordsTable';
import PageHeader from 'components/common/PageHeader';
import Label from 'components/general/Label';
import { ALL_URL } from 'helpers/utils';

export default function Records() {
    const { mirs_discipline, mirs_competition } = useUrlFriendlyToParameters();
    return (
        <>
            <PageHeader title={<Label data="HeaderRecords" />} />

            <div className='mirs-page-container'>

                {(mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) && <DisciplineRecords />}
                {(!mirs_discipline || mirs_discipline === ALL_URL.ALL_DISC) && <RecordsTable />}
            </div>
        </>
    );
};